
import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import rootReducer from './rootReducer';
import rootSaga from './rootSaga';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware({ 
        thunk: false,
        serializableCheck: {
            ignoredActionPaths: ['payload.file'],
        },
     }).concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export default store;
